import { Button, Divider, Modal, Space, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import VISA from '../../assets/visa.png';
import MASTERCARD from '../../assets/mastercard.png';
import AMREXP from '../../assets/amrexpress.png';
import UNIONPAY from '../../assets/unionpay.png';
import SSL from '../../assets/ssl.png';
import XSVG from '../../components/X';
import './plan.scss'
import classNames from 'classnames';
import YSVG from '../../components/Y';
import { useNavigate } from 'react-router-dom';
import Subscribe from './Subscribe';


export const plans = [
    {
        title: 'Free',
        price: 0,
        botLimit: 1,
        validChats: 100,
        trainingMaterials: 1,
        uploadFileSize: '1 Mb',
        chatHistory: '1 Day',
        addtionalChats: 0,
        reporting: 0,
        premiumCustomerSupport: 0,
        leads: 0,
        dataSecurity: false,
        buttonAction: false,
        chatbotBuildingServices: false,
        chatbotMatenance: false,
        dedicatedAcc: false,
    },
    {
        title: 'Starter',
        price: 40,
        botLimit: 1,
        validChats: 1000,
        trainingMaterials: 20,
        uploadFileSize: '3 Mb',
        chatHistory: '7 Days',
        addtionalChats: '$0.03',
        reporting: 'Basic',
        premiumCustomerSupport: '1 Month',
        leads: 'Enable',
        dataSecurity: true,
        buttonAction: false,
        chatbotBuildingServices: false,
        chatbotMatenance: false,
        dedicatedAcc: false,
    },
    {
        title: 'Advance',
        price: 100,
        botLimit: 3,
        validChats: 5000,
        trainingMaterials: 100,
        uploadFileSize: '10 Mb',
        chatHistory: '2 Months',
        addtionalChats: '$0.02',
        reporting: 'Advance',
        premiumCustomerSupport: '2 Months',
        leads: 'Enable',
        dataSecurity: true,
        buttonAction: true,
        chatbotBuildingServices: false,
        chatbotMatenance: false,
        dedicatedAcc: false,
    },
    {
        title: 'Business',
        price: 300,
        botLimit: 5,
        validChats: 15000,
        trainingMaterials: 300,
        uploadFileSize: '50 Mb',
        chatHistory: '1 Year',
        addtionalChats: '$0.01',
        reporting: 'Advance',
        premiumCustomerSupport: '1 Year',
        leads: 'Enable',
        dataSecurity: true,
        buttonAction: true,
        chatbotBuildingServices: false,
        chatbotMatenance: false,
        dedicatedAcc: false,
    },
    {
        title: 'Enterprise',
        price: -1,
        botLimit: 20,
        validChats: 'custom',
        trainingMaterials: 1000,
        uploadFileSize: '100 Mb',
        chatHistory: '3 Year',
        addtionalChats: '$0',
        reporting: 'Advance',
        premiumCustomerSupport: '3 Years',
        leads: 'Enable',
        dataSecurity: true,
        buttonAction: true,
        chatbotBuildingServices: true,
        chatbotMatenance: true,
        dedicatedAcc: true,
    },
];

function Plan(props) {

    const [selectedPlan, setSelectedPlan] = useState(-1);
    const [api, contextHolder] = message.useMessage();
    const [isOpen, setIsOpen] = useState(false);
    const [planIndex, setPlanIndex] = useState(false);
    const navigator = useNavigate();
    const plansRef = useRef([]);

    useEffect(() => {
        plansRef.current.forEach((ele, index) => {
            ele.addEventListener('mouseover', () => {
                setSelectedPlan(index)
            })
            ele.addEventListener('mouseout', () => {
                setSelectedPlan(-1);
            })
        });
    }, [])

    const getPlanContainerCss = (index) => classNames({
        'plan-container': true,
        'selected-plan': selectedPlan === index,
        'cursor-pointer': true,
    });


    const getLineThroughCss = (num) => classNames('item-content', 'item-text', {
        'line-through': (num === 0 || num === false) ? true : false,
    })

    // const handleSelectClick = async()=>{
    //     if(selectedPlan !== 0){
    //         api.info('Please contact admin to open choose premium plan.')
    //     }else{
    //         navigator('/home')
    //     }
    // }
    const handlePlanClick = (index) => {
        // navigator('/subscribe', {
        //     state: {index},
        // })
        setPlanIndex(index);
        setIsOpen(true);
    }
    return (
        <div className={`${props.outerConatiner ? 'plan-outer-container' : ''}`}>
            <div className='plan-outer-content-conatiner'>
                {contextHolder}
                <Space className='plan-header-container' direction='vertical' size='large'>
                    <h1 className='plan-title'>
                        Plans
                    </h1>
                    <span className='plan-notes'>
                        Pricing Plans For All You Need
                    </span>
                </Space >
                <Divider className='section-divider' />
                <br />
                <div className='plan-content-container'>
                    <div className='plans-container'>
                        {
                            plans.map((ele, index) => <ul
                                ref={r => plansRef.current[index] = r}
                                key={index}
                                className={getPlanContainerCss(index)}
                                onClick={() => handlePlanClick(index)}
                                
                            >
                                <Space className='plan-content' direction='vertical' size='small'>
                                    <div className='plan-header'>
                                        <h3>{ele.title}</h3>
                                    </div>
                                    <div className='price-container'>
                                        {
                                            ele.price !== -1 ?
                                                <>
                                                    <div className='price-cur price-text'>
                                                        CAD
                                                    </div>
                                                    <div className='price-amt'>
                                                        {ele.price}
                                                    </div>
                                                    <div className='price-dur price-text'>
                                                        /mo
                                                    </div>
                                                </> :
                                                <div className='price-amt price-amt-text'>
                                                    Please contact us
                                                </div>
                                        }
                                    </div>
                                    <ul className='items-container'>
                                        <li>
                                            <Space >
                                                <span className='item-amt item-text'>{ele.botLimit}</span>
                                                <span className='item-content item-text'>Bot limit</span>
                                            </Space>
                                        </li>
                                        <li>
                                            <Space>
                                                <span className='item-amt item-text'>{ele.validChats}</span>
                                                <span className='item-content item-text'>Valid chats/mo</span>
                                            </Space>

                                        </li>
                                        <li>
                                            <Space>
                                                <span className='item-amt item-text'>{ele.trainingMaterials}</span>
                                                <span className='item-content item-text'>Training material</span>
                                            </Space>

                                        </li>
                                        <li>
                                            <Space>
                                                <span className='item-amt item-text'>{ele.uploadFileSize}</span>
                                                <span className='item-content item-text'>Upload file size</span>
                                            </Space>
                                        </li>
                                        <li>
                                            <Space>
                                                <span className='item-amt item-text'>{ele.chatHistory}</span>
                                                <span className='item-content item-text'>Chat history</span>
                                            </Space>
                                        </li>
                                        {selectedPlan === index ?
                                            <div className='hidden-plan-container items-container'>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.addtionalChats === 0 ? <XSVG /> : <span className='item-amt item-text'>{ele.addtionalChats}</span>
                                                        }
                                                        <span className={getLineThroughCss(ele.addtionalChats)}>Additional valid chats</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.reporting === 0 ? <XSVG /> : <span className='item-amt item-text'>{ele.reporting}</span>
                                                        }
                                                        <span className={getLineThroughCss(ele.reporting)}>Reporting</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.premiumCustomerSupport === 0 ? <XSVG /> : <span className='item-amt item-text'>{ele.premiumCustomerSupport}</span>
                                                        }
                                                        <span className={getLineThroughCss(ele.premiumCustomerSupport)}>Premium customer support</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.leads === 0 ? <XSVG /> : <span className='item-amt item-text'>{ele.leads}</span>
                                                        }
                                                        <span className={getLineThroughCss(ele.leads)}>Leads</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.dataSecurity === false ? <XSVG /> : <YSVG />
                                                        }
                                                        <span className={getLineThroughCss(ele.dataSecurity)}>Data security</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.buttonAction === false ? <XSVG /> : <YSVG />
                                                        }
                                                        <span className={getLineThroughCss(ele.buttonAction)}>Button action</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.chatbotBuildingServices === false ? <XSVG /> : <YSVG />
                                                        }
                                                        <span className={getLineThroughCss(ele.chatbotBuildingServices)}>Chatbot building services</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.chatbotMatenance === false ? <XSVG /> : <YSVG />
                                                        }
                                                        <span className={getLineThroughCss(ele.chatbotMatenance)}>Chatbot maintenance</span>
                                                    </Space>
                                                </li>
                                                <li>
                                                    <Space>
                                                        {
                                                            ele.dedicatedAcc === false ? <XSVG /> : <YSVG />
                                                        }
                                                        <span className={getLineThroughCss(ele.dedicatedAcc)}>Dedicated acc. manager</span>
                                                    </Space>
                                                </li>
                                            </div> : null}
                                    </ul>
                                </Space>
                            </ul>)
                        }
                    </div>
                    <div style={{ height: '44px' }} />
                    {/* <div className='select-button-container'>
                    <Button className='select-button' onClick={handleSelectClick}>
                        Select
                    </Button>
                </div> */}
                    <div style={{ height: '44px' }} />
                </div>
                <div className='section-divider-grey-container'>
                    <div className='section-divider-grey' />
                </div>
                {/* <Divider className='section-divider-grey'/> */}
                <div style={{ height: '44px' }} />
                <div className='footer-outer-container'>
                    <div className='footer-container'>
                        <div className='footer-left-container'>
                            <span style={{ fontSize: '1rem', fontWeight: '500' }}>ACCEPTED PAYMENT METHODS</span>
                            <div className='icon-list'>
                                <img width={58} height={32} src={VISA} alt='visa' />
                                <img width={58} height={32} src={MASTERCARD} alt='mastercard' />
                                <img width={58} height={32} src={AMREXP} alt='americanexpress' />
                                <img width={58} height={32} src={UNIONPAY} alt='unionpay' />
                            </div>
                        </div>
                        <div className='footer-divider-container'>
                            <div className='footer-divider'></div>
                        </div>
                        <div className='footer-right-container'>
                            <img src={SSL} alt='ssl' width={48} height={48} />
                            <div style={{ width: '12px' }}></div>
                            <div className='footer-right-content'>
                                <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>SSL SECURE PAYMENT</span>
                                <div style={{ height: '12px' }}></div>
                                <div className='footer-text'>
                                    Your information is protected by 256-bit SSL encryption.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal open={isOpen} className='my-plan-modal-container' footer={false} closeIcon={false}>
                <Subscribe index={planIndex} onClose={()=>setIsOpen(false)}/>
            </Modal>
        </div>
    );
}

export default Plan;
